import { atom } from 'jotai';

/**
 * In-memory prefill message for Product Support inquiry handoff.
 * Kept out of URL params to avoid leaking sensitive content.
 */
export const productSupportPrefillMessageAtom = atom('');
